// extracted by mini-css-extract-plugin
module.exports = {"container":"button-advertising_container__dBNOF","container-disabled":"button-advertising_container-disabled__fgypa"};